import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvService } from './env.service';

export interface SmsVerificationRequest {
  phoneNumber: string;
  type: 'report_verification';
}

export interface SmsVerificationResponse {
  success: boolean;
  message?: string;
}

export interface OtpVerificationRequest {
  phoneNumber: string;
  otp: string;
  type: 'report_verification';
}

export interface OtpVerificationResponse {
  success: boolean;
  verified: boolean;
  message?: string;
  sessionToken?: string; // Backend-generated session token
}

export interface SessionValidationRequest {
  token: string;
}

export interface SessionValidationResponse {
  valid: boolean;
  phoneNumber?: string;
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SmsVerificationService {
  constructor(private httpClient: HttpClient, private env: EnvService) {}

  /**
   * Send verification code to phone number
   */
  sendVerificationCode(phoneNumber: string): Observable<SmsVerificationResponse> {
    const payload: SmsVerificationRequest = {
      phoneNumber,
      type: 'report_verification',
    };

    // Using backend_url for SMS verification (similar to existing auth flow)
    const url = `${this.env.environment.backend_url}${this.env.environment.api_v5}otp/request`;

    return this.httpClient.post<SmsVerificationResponse>(url, payload);
  }

  /**
   * Verify the OTP code
   */
  verifyCode(phoneNumber: string, code: string): Observable<OtpVerificationResponse> {
    const payload: OtpVerificationRequest = {
      phoneNumber,
      otp: code,
      type: 'report_verification',
    };

    const url = `${this.env.environment.backend_url}${this.env.environment.api_v5}otp/verify`;

    return this.httpClient.post<OtpVerificationResponse>(url, payload);
  }

  /**
   * Validate existing session token
   */
  validateSession(sessionToken: string): Observable<SessionValidationResponse> {
    const payload: SessionValidationRequest = {
      token: sessionToken,
    };

    const url = `${this.env.environment.backend_url}${this.env.environment.api_v5}otp/validate-session`;

    return this.httpClient.post<SessionValidationResponse>(url, payload);
  }
}
